import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Stack, Typography } from "components";
import { Policy } from "types";
import { getSignInUrl, getSignUpUrl } from "services";
import { reset } from "features/auth/authSlice";
import styles from "./SignIn.module.css";

const BANNER = process.env.PUBLIC_URL + "/images/pldt-signin-banner.png";
const MWELL_LOGO = process.env.PUBLIC_URL + "/images/logo-full.svg";
const WELCOME_TEXT_1 = "Welcome to";
const WELCOME_TEXT_2 = "Your Wellness Partner";

type SignInProps = {
  onPolicyChange(policy?: Policy): void;
};

const SignIn: React.FC<SignInProps> = ({ onPolicyChange }) => {
  const dispatch = useDispatch();
  const [signInUrl, setSignInUrl] = useState<string>();
  const [signUpUrl, setSignUpUrl] = useState<string>();

  useEffect(() => {
    let ignore = false;

    dispatch(reset());

    if (!ignore) {
      getSignInUrl().then(setSignInUrl);
      getSignUpUrl().then(setSignUpUrl);
    }

    return () => {
      ignore = true;
    };
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <img
        className={styles.image}
        src={BANNER}
        alt="Doctor"
        height="100%"
      />

      <Stack
        className={styles.content}
        direction="column"
        placeContent="center"
        placeItems="center"
        gap={4}
      >
        <Stack
          direction="column"
          placeItems="center"
          placeContent="center"
          gap={2}
          style={{ color: "#1565c0", width: "100%", textAlign: "center" }}
        >
          <Typography component="h1" size={4} weight={500}>
            {WELCOME_TEXT_1}
          </Typography>

          <img src={MWELL_LOGO} alt="mWell"  />

          <Typography component="h1" size={4} weight={500}>
            {WELCOME_TEXT_2}
          </Typography>
        </Stack>

        <Stack direction="column" gap={2}>
          <Button
            filled
            disabled={!signInUrl}
            link={signInUrl}
            onClick={() => onPolicyChange(undefined)}
          >
            Sign in
          </Button>

          <Stack gap={0.5}>
            <Typography component="p" whiteSpace="pre" align="center">
              No account yet?
            </Typography>

            <a
              className={styles.link}
              href={signUpUrl}
              onClick={() => onPolicyChange("B2C_1_Registration")}
            >
              Sign up
            </a>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};

export default SignIn;
